import * as React from 'react';
import { ComboBox, ListItemProps, ComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import { fetchApi } from '../services/api';

type Props = {
    callbackFromParent: (data: FacilitySearchResult) => void;
    className?: string;
    style?: {};
};

type State = {
    defaultValue: FacilitySearchResult | null;
    loading: boolean;
    opened: boolean;
    facilityResults: FacilitySearchResult[];
}

export interface FacilitySearchResult {
    FacilityId: number;
    Name: string;
}

export default class FacilityComboBox extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            defaultValue: null,
            loading: false,
            opened: false,
            facilityResults: [],
        };

        this.getFacilities();
    };

    itemRender = (li: any, itemProps: ListItemProps) => {
        const itemChildren = <span style={{ fontSize: "14px", fontFamily: "Arial, Helvetica, sans-serif", whiteSpace: "nowrap", overflow: "hidden" }}>{itemProps.dataItem.Name}</span>;
        return React.cloneElement(li, li.props, itemChildren);
    }

    onChange = (event: ComboBoxChangeEvent) => {
        this.props.callbackFromParent(event.target.value);
    }

    private getFacilities() {
        fetchApi('api/Facilities/List')
            .then((data: FacilitySearchResult[]) => {

                let _defaultSelectedFacility: FacilitySearchResult | undefined;
                const localStorageFacilityId = localStorage.getItem("FACILITY_ID");
                if (localStorageFacilityId) {
                    _defaultSelectedFacility = data.find(x => x.FacilityId === parseInt(localStorageFacilityId))
                }

                this.setState({
                    defaultValue: _defaultSelectedFacility || null,
                    facilityResults: data,
                    loading: false
                });

                if (_defaultSelectedFacility != null)
                    this.props.callbackFromParent(_defaultSelectedFacility);
            });
    }

    public render() {
        return (
            <ComboBox
                defaultValue={this.state.defaultValue}
                data={this.state.facilityResults}
                onChange={this.onChange}
                loading={this.state.loading}
                style={this.props.style}
                itemRender={this.itemRender}
                className={this.props.className}
                allowCustom={true}
                placeholder="Facility"
                suggest={true}
                textField="Name"
            />
        );
    }
}
